module.exports = "<router-outlet></router-outlet>  "


//////////////////
// WEBPACK FOOTER
// C:/TeamCity/BuildAgent3/work/c38c6eefb6a115e8/HSG.Accounting/HSG.Accounting.MonitoringMobileApp/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main